var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patterns"},_vm._l((3),function(i){return _c('div',{key:i,staticClass:"patterns__pattern",class:'patterns__pattern--' + i})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }